import React from 'react';
import { Box, Typography } from '@mui/material';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import { usePreviewAgent } from '../hooks';
import { formatPhone } from '../utils';
import PreviewContainer from './PreviewContainer';

const AgentContactBar: React.FC = () => {
  const { agentName, officeName, agentPhone } = usePreviewAgent();

  if (!agentName) return null;

  const leftParts = [agentName, officeName].filter(Boolean).join(' | ');

  return (
    <Box
      sx={{
        bgcolor: '#F8F8F8',
        color: '#344539',
        py: 2,
      }}
    >
      <PreviewContainer
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          flexWrap: 'wrap',
          gap: 2,
          my: 0,
        }}
      >
        <Box sx={{ textAlign: 'left' }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
            {leftParts}
          </Typography>
          <Typography variant="body2" sx={{ mt: 0.5, opacity: 0.9 }}>
            See an error? Contact me to make corrections.
          </Typography>
        </Box>
        {agentPhone && (
          <Box
            sx={{
              alignItems: 'center',
              display: 'flex',
              gap: 2,
              textAlign: 'right',
            }}
          >
            <PhoneOutlinedIcon />
            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
              {formatPhone(agentPhone)}
            </Typography>
          </Box>
        )}
      </PreviewContainer>
    </Box>
  );
};

export default React.memo(AgentContactBar);
